export default function ({ from }) {
  const scrollPos = from && from.meta.length ? from.meta[0].scrollPos : null

  const contentWrapper = document.getElementById('content-wrapper-' + from.name)
  if (contentWrapper && scrollPos && Object.keys(scrollPos).length > 0) {
    scrollPos.y = contentWrapper.scrollTop || 0
    scrollPos.x = 0
  }
}
